
import { withRouter, Prompt } from 'react-router'
import { Link, Switch, Route } from 'react-router-dom'
import React, { Component } from 'react'
import { CSSTransition } from "react-transition-group"
import { connect } from 'react-redux'
import { sendMethod } from '../../actions/devTools'
import { Formik } from 'formik'
import NavItem from '../utilities/NavItem'
import NavContent from '../utilities/NavContent'
import FormButtonPanel from '../utilities/FormButtonPanel'
import JsonViewer from '../utilities/tabs/jsonViewer'
import moment from 'moment'
import AceEditor from 'react-ace'
import ReactJson from "react-json-view";
import 'brace/mode/json'
import 'brace/theme/github'
import _ from 'lodash'

class DevelopersToolsForm extends Component {
    constructor(props) {
        super(props)

        this.state = {
            endpoints: props.endpoints,
            resultStatus:"",
            resultTime:"",
            resultResponse:{}
        }

    }

    breadCrumb() {
        let breadCrumb = window.location.href.split('/')
        return breadCrumb
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            endpoints: nextProps.endpoints,
            ACLEndpointList: nextProps.ACLEndpointList,
            isFetching: nextProps.isFetching
        })
    }

    render() {

        let {
            isFetching,
            resultResponse,
            resultStatus,
            resultStatusText,
            resultOk,
            resultTime
        } = this.state

        // console.log("resultResponse",resultResponse)
        // console.log("resultStatus",resultStatus)
        // console.log("resultTime",resultTime)
        
        let {
            endpoints,
            dispatch,
            auth,
        } = this.props





        // let initVal = {
        //     name:"",
        //     devConnection:"",
        //     devDatasource:""
        // }

        let objProp = {}

        let initVal = Object.assign({}, {
            devConnection:0,
            devDatasource:0,
            methodValue:"get",
            urlValue:"",
            bodyValue:""
          
        }, objProp)


        let getConnectionList
        let getDatasourceList

        let methods = ['POST','GET','PUT','DELETE']

        let bodyTabList = ['Body']

        let resultTabList = ['Response','Status','Time']

        let methodsObj = [
            {
                name:'GET',
                type:'get',
                id:'1'
            },
            {

                name:'POST',
                type:'post',
                id:'2'
            },
            {
                name:'DELETE',
                type:'Delete',
                id:'3'
            },
            {
                name:'PATCH',
                type:'Patch',
                id:'4'
            },
        ]
    
        for (let n in endpoints) {
            if (endpoints[n].name === "connections") {
                getConnectionList = endpoints[n].list
            }else if(endpoints[n].name === "datasources"){
                getDatasourceList = endpoints[n].list
            }
        }

        return (
            <div className="working-area-content">
                <div className="component-title list-group" id="working-area">
                    <div className="list-group-item list-group-item-action gradient-background">
                        <div className="" id="endpoint-label-wrapper">
                            <div className="float-left breadcrumbs">
                                <div className="">
                                    <p>
                                        <Link to={'/'}><i className="fas fa-th"></i></Link>
                                        <i className="fas fa-arrow-right"></i>
                                        <Link to={`/${this.breadCrumb()[3]}`}>
                                            Developers Tools
                                        </Link>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <Formik
                        initialValues={initVal}
                        validateOnChange={true}
                        validateOnBlur={false}
                        validate={(values)=>{

                            // console.log("values",values)

                            let errors ={}

                            if(values.methodValue == "get"){
                                if(!values.urlValue){
                                    errors.urlValue = "This field is required"
                                }
                                if(values.devConnection == 0){
                                    errors.devConnection = "Select Connection"
                                }
                                if(values.devDatasource == 0){
                                    errors.devDatasource = "Select Datasource"
                                }
                            }else if(values.methodValue != "get"){
                                if(!values.urlValue){
                                    errors.urlValue = "This field is required"
                                }
                                if(values.devConnection == 0){
                                    errors.devConnection = "Select Connection"
                                }
                                if(values.devDatasource == 0){
                                    errors.devDatasource = "Select Datasource"
                                }
                                if(!values.bodyValue){
                                    errors.bodyValue = "This field is required"
                                }
                            }

                            
                            // if(values.methodValue == "get"){
                            //     if(!values.urlValue){
                            //         errors.urlValue = "This field is required"
                            //     }
                            //     if(values.devConnection == 0){
                            //         errors.devConnection = "Select Connection"
                            //     }
                            //     if(values.devDatasource == 0){
                            //         errors.devDatasource = "Select Datasource"
                            //     }
                            // }

                            // if(!values.urlValue){
                            //     errors.urlValue = "This field is required"
                            // }else if(!values.bodyValue && values.methodValue != "get"){
                            //     errors.bodyValue = "This field is required"
                            // }


                            return errors
                        }}
                        onSubmit={(values, actions) => {
                            // setTimeout(() => {
                            // alert(JSON.stringify(values, null, 2));
                            // actions.setSubmitting(false);
                            // }, 1000);

                            // actions.validateField(true)


                            // console.log("values",values)

                            let body={}

                            if(values.methodValue ==="get"){
                                body={
                                    connection_id:Number(values.devConnection),
                                    datasource_id:Number(values.devDatasource),
                                    method:values.methodValue,
                                    url:values.urlValue
                                }
                            }else{
                                let jsonVal = JSON.parse(values.bodyValue)
                                body={
                                    connection_id:Number(values.devConnection),
                                    datasource_id:Number(values.devDatasource),
                                    method:values.methodValue,
                                    url:values.urlValue,
                                    body:jsonVal
                                }
                            }

                            let token = auth.access_token

                            // let objBody = Object.assign({},body)

                            // console.log("test",test)                
                            dispatch(sendMethod(token,body))
                            .then((response) => {
                                // console.log("response",response)

                                // for (var pair of response.headers.entries()) { // accessing the entries
                                //     // console.log("pair",pair)
                                //     console.log(pair[0]+ ': '+ pair[1]);
                                // }

                                let jsonResponse = response.clone().json().then((responseJSON)=>{
                                    // console.log("response.JSON",responseJSON)
                                    this.setState({
                                        resultResponse:responseJSON
                                    })
                                })

                                if(response.status){
                                    this.setState({
                                        resultStatus:response.status
                                    })
                                }

                                if(response.statusText){
                                    this.setState({
                                        resultStatusText:response.statusText
                                    })
                                }

                                if(response.ok){
                                    this.setState({
                                        resultOk:response.ok.toString()
                                    })
                                }else{
                                    this.setState({
                                        resultOk:response.ok.toString()
                                    })
                                }


                                let getDate = moment().format('MM-DD-YYYY HH:mm:ss')

                                if(getDate){
                                    this.setState({
                                        resultTime:getDate
                                    })
                                }
                                // console.log("getDate",getDate)
                            })
                            .catch(error=>{
                              
                            })
                        }}
                        render={({
                            handleSubmit,
                            handleChange,
                            setFieldValue,
                            values,
                            errors
                        }) => {

                            let mainPaneFields = []

                            let methodsDetailsFields = []

                            let bodyKeycount = 0
                            let bodyTabCounter = 0
                            let bodyDetailsTabs = []
                            let bodyDetailsFields = []

                            let resultsKeyCount = 0
                            let resultsTabCounter = 0
                            let resultsDetailsTabs = []
                            let resultsDetailsFields = []

                            let test = Object.assign({}, {
                                devConnection:0,
                                devDatasource:0,
                                methodValue:"get",
                                urlValue:"",
                                bodyValue:""
                              
                            }, objProp)
                            
                            if(getConnectionList){
                                mainPaneFields.push(
                                    <div key={"connection-key"} className="connections prop-header" >
                                            <div className="col-12 mt-3">
                                            {/* <label className="my-0">Connection: </label> */}
                                            <label>Connection: </label>
                                            <select onChange={handleChange} disabled={false} name="devConnection" values={values.devConnection}   className={"form-control"}>
                                            <option key={0} value={0} className={ ""}>
                                                Select Connection
                                            </option>
                                                {
                                                    
                                                    getConnectionList.map(gcl => {
                                                        let hideOption =  gcl.id
                                                        let inactive = gcl.status === 0 ? true:false
                                                        let hideInactive =  gcl.id && inactive
                                                        return (
                                                            <option key={gcl.id} value={gcl.id} className={hideInactive? "d-none": ""}>
                                                                {gcl.name} {inactive && "(Inactive)"}
                                                            </option>
                                                        )
                                                    })
                                                }
                                            </select>
                                            {errors.devConnection &&  
                                                <div className="invalid-devtools">
                                                    {errors.devConnection  ? errors.devConnection: ""}
                                                </div>
                                            }
                                        </div>
                                    </div>
                                )

                            }
                            if(getDatasourceList){
                                mainPaneFields.push(
                                    <div key={"datasource-key"} className="datasource prop-header" >
                                            <div className="col-12 mt-3">
                                            {/* <label className="my-0">Datasource: </label> */}
                                            <label >Datasource: </label>
                                            <select onChange={handleChange} disabled={false} name="devDatasource" values={values.devDatasource}  className={"form-control"}>
                                            <option key={0} value={0} className={ ""}>
                                                Select Datasource
                                            </option>
                                                {
                                                    getDatasourceList.map(gdl => {
                                                        let hideOption =  gdl.id
                                                        let inactive = gdl.status === 0 ? true:false
                                                        let hideInactive =  gdl.id && inactive
                                                        return (
                                                            <option key={gdl.id} value={gdl.id} className={hideInactive? "d-none": ""}>
                                                                {gdl.name} {inactive && "(Inactive)"}
                                                            </option>
                                                        )
                                                    })
                                                }
                                            </select>
                                            {errors.devDatasource &&  
                                                <div className="invalid-devtools">
                                                    {errors.devDatasource  ? errors.devDatasource: ""}
                                                </div>
                                            }
                                        </div>
                                    </div>
                                )
                            }

                            methodsDetailsFields.push(
                            <div  key={"detail-container-key"} className="row pt-3 detail-container">
                                {/* <div className="text-right col-1 pt-3">
                                    <label >METHOD:</label>
                                </div> */}
                               <div className="method-col col-2 pt-3">
                                   
                                    <select className="devtools-method form-control" onChange={handleChange} name="methodValue" value={values.methodValue} id="devtools-method">
                                        {
                                            methodsObj.map(mObj => {
                                                return (
                                                    <option key={mObj.type} value={mObj.type} className={""}>
                                                        {mObj.name}
                                                    </option>
                                                )
                                            })
                                        }
                                    </select>
                                </div>
                                {/* <div className="text-right col-1 pt-3">
                                    <label>URL:</label>
                                </div> */}
                                <div className="url-col col-8 pt-3">
                                    <div className="url-inputs">
                                        <input type="text" name="urlValue" onChange={handleChange} value={values.urlValue} className="devtools-url form-control" id="devtools-url"  aria-describedby="basic-addon1"/>
                                       {errors.urlValue &&  
                                        <div className="invalid-devtools">
                                            {errors.urlValue  ? errors.urlValue: ""}
                                        </div>
                                        }
                                    </div>
                                </div>
                                <div className="col-2 pt-3">
                                    <button type="submit" className="btn btn-primary">Submit</button>
                                </div>
                            </div>
                            )

                            for (let b in bodyTabList){
                                bodyDetailsTabs.push(
                                    <NavItem
                                        active={bodyTabCounter === 0 ? "active" : ""}
                                        key={`${bodyTabList[b]}-${bodyKeycount}-tabheader`}
                                        name={`${bodyTabList[b]}-${bodyKeycount}`}
                                        value={bodyTabList[b]}
                                        selected={true}
                                    />
                                )

                                bodyDetailsFields.push(
                                    <NavContent
                                        key={`${bodyTabList[b]}-${bodyKeycount}-tabcontent`}
                                        id={`${bodyTabList[b]}-${bodyKeycount}`}
                                        active={bodyTabCounter === 0 ? "show active" : ""}
                                        content={
                                            <div className="p-2">
                                                <AceEditor
                                                    mode="json"
                                                    theme="github"                                                    
                                                    width="100%"
                                                    height="100%"
                                                    style={{ minHeight: 300 }}
                                                    fontSize={14}
                                                    showPrintMargin={false}
                                                    showGutter={true}
                                                    highlightActiveLine={false}
                                                    name={"devTools-ace-editor"}
                                                    editorProps={{ $blockScrolling: true }}
                                                    debounceChangePeriod={500}
                                                    value={values.bodyValue}
                                                    onChange={value => setFieldValue("bodyValue", value)}
                                                    readOnly={values.methodValue=="get"?true:false}
                                                /> 
                                            {errors.bodyValue &&  
                                                <div className="invalid-devtools">
                                                    {errors.bodyValue  ? errors.bodyValue: ""}
                                                </div>
                                            }
                                            </div>
                                         
                                        }
                                    />
                                )
                                bodyTabCounter++

                            }

                            for (let c in resultTabList){
                                if(resultTabList[c] === "Status"){
                                    resultsDetailsTabs.push(
                                        <NavItem
                                            active={resultsTabCounter === 0 ? "active" : ""}
                                            key={`${resultTabList[c]}-${resultsKeyCount}-tabheader`}
                                            name={`${resultTabList[c]}-${resultsKeyCount}`}
                                            value={resultTabList[c]}
                                            selected={true}
                                        />
                                    )
    
                                    resultsDetailsFields.push(
                                        <NavContent
                                            key={`${resultTabList[c]}-${resultsKeyCount}-tabcontent`}
                                            id={`${resultTabList[c]}-${resultsKeyCount}`}
                                            active={resultsTabCounter === 0 ? "show active" : ""}
                                            content={
                                                <div className="p-2">
                                                    {this.state.resultStatus? 
                                                    <div>
                                                    Status Code: {this.state.resultStatus }<br/>
                                                    Status:{this.state.resultStatusText }<br/>
                                                    Success: {this.state.resultOk }<br/>
                                                    </div>: ""}
                                                    {/* <JsonTableViewer value={sortFilteredAuditList} user={getUserList} /> */}
                                                </div>
                                            }
                                        />
                                    )

                                }else if(resultTabList[c] === "Time"){
                                    resultsDetailsTabs.push(
                                        <NavItem
                                            active={resultsTabCounter === 0 ? "active" : ""}
                                            key={`${resultTabList[c]}-${resultsKeyCount}-tabheader`}
                                            name={`${resultTabList[c]}-${resultsKeyCount}`}
                                            value={resultTabList[c]}
                                            selected={false}
                                        />
                                    )
    
                                    resultsDetailsFields.push(
                                        <NavContent
                                            key={`${resultTabList[c]}-${resultsKeyCount}-tabcontent`}
                                            id={`${resultTabList[c]}-${resultsKeyCount}`}
                                            active={resultsTabCounter === 0 ? "show active" : ""}
                                            content={
                                                <div className="p-2">
                                                         {this.state.resultTime?                                                     
                                                         <div>
                                                            Time: {this.state.resultTime }
                                                        </div>: ""}
                                                    {/* <JsonTableViewer value={sortFilteredAuditList} user={getUserList} /> */}
                                                </div>
                                            }
                                        />
                                    )

                                }else if(resultTabList[c] === "Response"){
                                    resultsDetailsTabs.push(
                                        <NavItem
                                            active={resultsTabCounter === 0 ? "active" : ""}
                                            key={`${resultTabList[c]}-${resultsKeyCount}-tabheader`}
                                            name={`${resultTabList[c]}-${resultsKeyCount}`}
                                            value={resultTabList[c]}
                                            selected={false}
                                        />
                                    )
    
                                    resultsDetailsFields.push(
                                        <NavContent
                                            key={`${resultTabList[c]}-${resultsKeyCount}-tabcontent`}
                                            id={`${resultTabList[c]}-${resultsKeyCount}`}
                                            active={resultsTabCounter === 0 ? "show active" : ""}
                                            content={
                                                <div className="p-2">
                                                     {this.state.resultResponse?  
                                                        <div className="devtools-response">
                                                            {/* <JsonViewer value={JSON.stringify(this.state.resultResponse)} name={'data'} collapsed={1} /> */}
                                                            <ReactJson
                                                                name={'data'}
                                                                src={this.state.resultResponse}
                                                                theme="bright:inverted"
                                                                displayDataTypes={false}
                                                                displayObjectSize={false}
                                                                collapsed={1}
                                                                iconStyle={"circle"}
                                                                enableClipboard={false}
                                                            />
                                                        </div> :""}
                                                    {/* <JsonTableViewer value={sortFilteredAuditList} user={getUserList} /> */}
                                                </div>
                                            }
                                        />
                                    )

                                }
                               
                                resultsTabCounter++
                            }


                            return(
                                <CSSTransition
                                in={true}
                                appear={true}
                                timeout={500}
                                classNames="fade"
                            >
                             
                                        <div id="working-area-content" className="working-area-content-about">
                                            <form onSubmit={handleSubmit}>
                                            <div className="devtools-main-pane">
                                                {mainPaneFields}
                                                {errors.name && <div id="feedback">{errors.name}</div>}
                                                
                                            </div>
                                            <div className="devtools-details-pane">
                                                <div className="devtools-method-pane">
                                                    {methodsDetailsFields}
                                                </div>
                                                <div className="devtools-body-pane">
                                                    {/* <div className="json-data-wrapper"> */}
                                                        {/* <div className="json-data-header"> */}
                                                            <ul className="nav nav-tabs" id="json-tab" role="tablist">
                                                            {bodyDetailsTabs}
                                                            </ul>
                                                        {/* </div> */}
                                                        <div className="tab-content margined" id="generic-tab-content">
                                                            {bodyDetailsFields}
                                                        </div>
                                                    {/* </div> */}
                                                </div>
                                                <div className="devtools-results-pane">
                                                    <div className="json-data-wrapper">
                                                        <div className="json-data-header">
                                                            <ul className="nav nav-tabs" id="json-tab" role="tablist">
                                                            {resultsDetailsTabs}
                                                            </ul>
                                                        </div>
                                                        <div className="tab-content margined" id="generic-tab-content">
                                                            {resultsDetailsFields}
                                                    </div>
                                                    </div>
                                                </div>
                                            </div>
                                            </form>
                                        </div>
                                
                            </CSSTransition>
                             
                            )
                        }}
                        >               
                    </Formik>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
   return {
        endpoints: state.endpoints,
        main: state.main,
        auth: state.auth,
        messageBox: state.messageBox
    }
}

export default withRouter(connect(mapStateToProps)(DevelopersToolsForm))


// WEBPACK FOOTER //
// ./src/components/developersTools/devlopersToolsForm.js